var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImportIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M16.0004 13.8182V4.96613C16.0004 4.58036 15.8471 4.21039 15.5743 3.93761L12.0628 0.426029C11.79 0.153244 11.42 0 11.0342 0H5.81854C4.61356 0 3.63672 0.976836 3.63672 2.18182V13.8182C3.63672 15.0232 4.61356 16 5.81854 16H13.8185C15.0236 16 16.0004 15.0232 16.0004 13.8182Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0339 0C11.4196 0 11.7896 0.153244 12.0624 0.426029L15.574 3.93761C15.8468 4.21039 16 4.58036 16 4.96613V5.09091H12.3636C11.5603 5.09091 10.9091 4.43969 10.9091 3.63636V0H11.0339ZM9.9688 10.6961L7.78705 12.8779C7.50305 13.1619 7.04255 13.1619 6.75855 12.8779C6.47449 12.5939 6.47449 12.1334 6.75847 11.8494L7.69876 10.9091H0.727273C0.325607 10.9091 0 10.5835 0 10.1818C0 9.78014 0.325607 9.45454 0.727273 9.45454H7.69876L6.75847 8.51425C6.47449 8.23025 6.47449 7.76975 6.75855 7.48575C7.04255 7.20175 7.50305 7.20175 7.78705 7.48575L9.9688 9.66756C10.2528 9.95156 10.2528 10.4121 9.9688 10.6961Z",
    fill: "current",
    fillOpacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImportIcon);
export default __webpack_public_path__ + "static/media/ImportIcon.95aded14470bdc89bc8129a58885a38a.svg";
export { ForwardRef as ReactComponent };